import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import GraphUrine from "./graph-urine";
import "./styles.scss";
import GraphCalendar from "./graph-calendar";
import { getUserInfo } from "utils";
import dayjs from "dayjs";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { apiGetRecordSorted } from '../../helpers/api/records'

const MODE = {
  CALENDAR: 0,
  CHART: 1,
};

const GraphComponent = () => {
  const userInfo = getUserInfo();
  const [mode, setMode] = useState(0);
  const { t } = useTranslation();
  const { id } = useParams();
  const [dateSelected, setDateSelected] = useState(dayjs());
  const [treatmentDate, setTreatmentDate] = useState(null);

  useEffect(() => {
    apiGetRecordSorted(id).then(result => {
      const { data } = result
      if (data && data.length > 0) {
        setTreatmentDate(dayjs(new Date(data[0])))
      }
    })
  }, []);

  return (
    <div className="graph-component-container">
      <div className="root-right-header">
        <div className="screen-name">{userInfo.role == "ROLE_ADMIN" ? "三和Admin" : userInfo.clinic_name + " " + t("prefix")}</div>
        <div className="chart-switch-sesstion" style={{ marginRight: "50px" }}>
          <div
            className={`chart-button ${mode === MODE.CALENDAR ? "chart-button-active" : ""
              }`}
            style={{ marginRight: "30px" }}
            onClick={() => setMode(MODE.CALENDAR)}
          >
            {t("graph.calendar")}
          </div>
          <div
            className={`chart-button ${mode === MODE.CHART ? "chart-button-active" : ""
              }`}
            onClick={() => setMode(MODE.CHART)}
          >
            {t("graph.graph")}
          </div>
        </div>
      </div>
      {mode === MODE.CALENDAR ? (
        <GraphCalendar
          dateSelected={dateSelected}
          setDateSelected={setDateSelected}
          patientId={id}
          treatmentDate={treatmentDate}
        />
      ) : (
        <GraphUrine patientId={id} dateSelected={dateSelected} setDateSelected={setDateSelected} treatmentDate={treatmentDate} />
      )}
    </div>
  );
};

export default GraphComponent;
